export const extractErrorMessage = (err: any) => {
    const errorMessage = err?.response?.data?.message || err?.message || err;
    return errorMessage;
};
